import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DownloadMandateUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.downloadMandate(req);
    }
}
export default DownloadMandateUseCase;
